<af-main-container [title]="(isAdmin ? 'i18n_af_makeTrendConclusion' : 'i18n_af_rateTrend') | translate"
                   [customLastBreadcrumb]="trendId && 'i18n_lib_breadcrumb#TrendId' | translate :{trendId: trendId}"
                   [tabPathToTab]="tabPathToTab"
                   [buttonSpinnerId]="'save'"
                   [navigateBackListener]="navigateBack"
                   (buttonClickListener)="save()">
    @if (form) {
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px"
              class="bc-mono-white radius-16 w-100 p-24 mt-24">
            <div class="grid-form-container mt-24">
                @if (isAdmin) {
                    <af-dictionary-selector class="w-400"
                        [dictionaryName]="ReferenceBookType.TREND_STATUS"
                        [control]="form.controls.status"
                        label="i18n_af_labelTrendStatus"
                        placeholder="i18n_af_placeholderSelectTrendStatus"/>
                } @else {
                    <af-dictionary-selector class="w-400"
                        [dictionaryName]="ReferenceBookType.TREND_RATE"
                        [control]="form.controls.rate"
                        label="i18n_af_labelTrendRate"
                        placeholder="i18n_af_placeholderSelectTrendRate"/>
                }

                <af-dictionary-selector class="w-400"
                    [dictionaryName]="ReferenceBookType.TREND_RELEVANCE"
                    [control]="form.controls.relevance"
                    label="i18n_af_labelTrendRelevance"
                    placeholder="i18n_af_placeholderSelectTrendValue"/>

                <af-dictionary-selector class="w-400"
                    [dictionaryName]="ReferenceBookType.TREND_REASON"
                    [control]="form.controls.reason"
                    label="i18n_af_labelTrendReason"
                    placeholder="i18n_af_placeholderSelectTrendReason"/>

                <af-dictionary-selector class="w-400"
                    [dictionaryName]="ReferenceBookType.TREND_CONFIDENCE"
                    [control]="form.controls.confidence"
                    label="i18n_af_labelTrendСonfidence"
                    placeholder="i18n_af_placeholderSelectTrendValue"/>
            </div>

            <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelComment' | translate }}</div>
                <mat-form-field class="mt-4 w-100" [class.value-not-empty]="form.controls.comment.value">
                <textarea matInput
                          #commentArea
                          [maxlength]="250"
                          class="resize-none pt-12 pb-12"
                          [placeholder]="'i18n_af_placeholderTrendRateComment' | translate"
                          [formControl]="form.controls.comment"></textarea>
                    <mat-hint align="start" class="t5 c-primary-gray-600">
                        {{
                            'i18n_af_hintMaxLength' | translate: {
                                current: commentArea.value.length,
                                max: 250
                            }
                        }}
                    </mat-hint>
                </mat-form-field>
            </div>


            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" class="mt-40">
                <ui-kit-button spinnerId="save"
                               [disabled]="form.invalid"
                               [label]="'i18n_af_buttonSave' | translate"
                               (clickListener)="save()"/>
                <ui-kit-button color="accent"
                               buttonType="button"
                               type="text"
                               (clickListener)="navigateBack()"
                               [label]="'i18n_af_buttonCancel' | translate"/>
            </div>
        </form>
    }
</af-main-container>
